import React from 'react';
import styled from 'styled-components';
import { Heading, Text, Flex, Spacer, colors } from '@badi/badi-components';
import { translate } from 'base/shared/Localization';
import BadiGuaranteeCard from 'components/badi-guarantee-card';
import RoomDetailBadge from 'components/room-detail-badge';
import { getPublicAsset } from 'base/shared/Utils';

const LogoImg = styled.img`
  width: 120px;
  height: auto;
`;

const PolicyItem = ({ title, description }) => (
  <Spacer bottom={3}>
    <Text body={2} weight="bold">
      {title}
    </Text>
    <Text body={3}>{description}</Text>
  </Spacer>
);

const Separator = styled.hr`
  border: none;
  border-top: 1px solid ${colors.grayLight};
  margin: 0;
`;

const BadiPlusListingDetails = ({ room, userRole }) => {
  return (
    <Spacer top={2}>
      <Spacer bottom={3} top={3}>
        <BadiGuaranteeCard
          cta={translate('badiplus_checkout_badi_guarantee_cta')}
          title={translate('badiplus_checkout_badi_guarantee_title')}
          userRole={userRole}
        />
      </Spacer>
      <RoomDetailBadge {...room} clickable={false} />

      <Spacer bottom={4} top={4}>
        <Separator />
      </Spacer>

      <Spacer bottom={3}>
        <LogoImg alt="badiplus" src={getPublicAsset('/images/badiplus-logo.png')} />
      </Spacer>
      <Text body={3}>{translate('badiplus_checkout_description')}</Text>

      <Spacer bottom={4} top={4}>
        <Separator />
      </Spacer>

      <Heading level={2} weight="bold">
        {translate('badiplus_checkout_policies_title')}
      </Heading>
      <Spacer top={3}>
        <PolicyItem
          description={translate('badiplus_checkout_policy_deposit_description')}
          title={translate('badiplus_checkout_policy_deposit_title')}
        />
        <PolicyItem
          description={translate('badiplus_checkout_policy_fee_description')}
          title={translate('badiplus_checkout_policy_fee_title')}
        />
        <PolicyItem
          description={translate('badiplus_checkout_policy_cleaning_description')}
          title={translate('badiplus_checkout_policy_cleaning_title')}
        />
        <PolicyItem
          description={translate('badiplus_checkout_policy_couples_description')}
          title={translate('badiplus_checkout_policy_couples_title')}
        />
      </Spacer>

      <Spacer top={2}>
        <Text body={3}>
          {translate('badiplus_checkout_check_our')}{' '}
          <a
            style={{ textDecoration: 'underline' }}
            href={translate('sitemap.badiplus.tc.link')}
            rel="noopener noreferrer"
            target="_blank"
          >
            {translate('badiplus_checkout_terms_conditions')}
          </a>
        </Text>
      </Spacer>
    </Spacer>
  );
};

export default BadiPlusListingDetails;
